// This file transforms the JSON object into a FormData object and control the values of the keys of type:
// string | number | boolean | File | Date | null | undefined | array | object.

const jsonToFormData = (json, parentPrefix) => {
  const formData = new FormData();
  const keys = Object.keys(json);
  keys.forEach((key) => {
    const formKey = parentPrefix ? `${parentPrefix}[${key}]` : key;
    const value = json[key];
    switch (true) {
      case value.instanceOf === 'File':
        formData.append(formKey, value);
        break;
      case value.instanceOf === 'Date':
        formData.append(formKey, value.toISOString());
        break;
      case value === null || typeof value === 'undefined':
        formData.append(formKey, '');
        break;
      case Array.isArray(value):
        value.forEach((element) => {
          const valueArray = typeof element === 'object' ? JSON.stringify(element) : element;
          formData.append(`${formKey}[]`, valueArray);
        });
        break;
      case value.instanceOf === 'Object':
        formData.append(formKey, JSON.stringify(value));
        break;

      default:
        formData.append(formKey, value);
        break;
    }
  });
  return formData;
};

// eslint-disable-next-line import/prefer-default-export
export { jsonToFormData };
